<template>
  <div v-if="show">
    <div class="menuFrame">
      <div class="container py-3">
        <div
          class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
        >
          <a href="https://www.chanchao.com.tw/en/">
            <div class="d-flex align-items-center">
              <img
                src="../../assets/images/ChanChaoLogo.png"
                class="navLogo mt-2"
              />
              <div class="mx-2 logoText text-dark font-weight-nomal">
                <div>សមាជិក Chan Chao</div>
              </div>
            </div>
          </a>

          <div>
            <select
              class="form-control language-select"
              v-model="selectedLang"
              @change="switchLanguage"
            >
              <option
                v-for="lang in languages"
                :key="lang.value"
                :value="lang.value"
              >
                {{ lang.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row formFrame m-1 py-2 mr-3 justify-content-center">
          <div class="col-md-6 my-4 px-4">
            <div class="d-flex align-items-center mb-5">
              <img
                src="../../assets/images/PwIcon.png"
                class="mr-2 mb-2"
                style="width: 30px; height: 30px"
                alt=""
              />
              <h4>កំណត់ពាក្យសម្ងាត់ឡើងវិញ</h4>
            </div>
            <form class="mt-5">
              <div class="form-group h6">
                <label for="resetPassword1">លេខសម្ងាត់</label>
                <div class="input-group mb-3">
                  <input
                    type="password"
                    :type="typePwd"
                    class="form-control"
                    id="resetPassword1"
                    maxlength="20"
                    placeholder="8-20 characters"
                    aria-describedby="emailHelp"
                    v-model="password"
                    autocomplete="off"
                    name="password"
                    :class="{ 'is-invalid': errors.first('password') }"
                    v-validate="'required'"
                    ref="password"
                    data-vv-as="Password"
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      @click.prevent="showPw"
                    >
                      <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                      <i
                        class="fas fa-eye-slash"
                        v-else="typePwd == 'text'"
                      ></i>
                    </span>
                  </div>
                </div>
                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('password')"
                  >{{ errors.first("password") }}
                </span>
              </div>

              <div class="form-group h6">
                <label for="resetPassword2">បញ្ជាក់ពាក្យសម្ងាត់</label>
                <div class="input-group mb-3">
                  <input
                    type="password"
                    :type="typePwd"
                    class="form-control"
                    id="resetPassword2"
                    placeholder="Enter password again"
                    aria-describedby="emailHelp"
                    maxlength="20"
                    autocomplete="off"
                    v-model="confirmcode"
                    name="password_confirmation"
                    :class="{
                      'is-invalid': errors.first('password_confirmation'),
                    }"
                    v-validate="'required|confirmed:password'"
                    data-vv-as="Confirm Password"
                    ref="passwordconfirm"
                  />

                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      id="basic-addon2"
                      @click.prevent="showPw"
                    >
                      <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                      <i
                        class="fas fa-eye-slash"
                        v-else="typePwd == 'text'"
                      ></i>
                    </span>
                  </div>
                </div>
                <span
                  class="text-danger"
                  style="font-size: 10px"
                  v-if="errors.first('password_confirmation')"
                  >{{ errors.first("password_confirmation") }}
                </span>
              </div>
              <button
                type="submit"
                class="btn btn-block btn-primary mt-4"
                @click.prevent="resetpw"
              >
                ដាក់ស្នើ
              </button>
            </form>

            <div v-if="!Registered">
              <hr />

              <div class="linkFrame">
                <!-- <router-link to="/en/login">ចូល </router-link> -->
                <a href="https://www.chanchao.com.tw/accounts/km/login">ចូល</a>

                /
                <span>
                  អ្នកមិនទាន់ក្លាយជាសមាជិកទេ
                  <!-- <router-link to="/en/signup">ចុះឈ្មោះ</router-link> -->
                  <a href="https://www.chanchao.com.tw/accounts/km/signup"
                    >ចុះឈ្មោះ</a
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/footer_en.vue";

export default {
  metaInfo: {
    title: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ - បណ្តាញពិព័រណ៍ Chan Chao",
  },
  components: {
    Footer,
  },

  data() {
    return {
      password: "",
      confirmcode: "",
      typePwd: "password",
      access_token: "",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      menberId: "",
      verifyCode: "",
      show: false,
      CSRF_Token: "",
      Registered: false,
      selectedLang: "km",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
        { label: "বাংলা ভাষা", value: "bd" },
      ],
    };
  },

  watch: {
    password: function () {
      const vm = this;
      vm.$refs.password.style.borderColor = "#ced4da";
    },

    confirmcode: function () {
      const vm = this;
      vm.$refs.passwordconfirm.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/resetPw`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/resetPw`;
      }
    },
    resetpw() {
      const vm = this;
      const url = "https://www.chanchao.com.tw/apiLogin2/resetPw";
      const resetinfo = {
        spass: vm.password,
        as: vm.access_token,
        c: vm.verifyCode,
        e: vm.menberId,
        CSRF: vm.CSRF_Token,
      };
      // // console.log(resetinfo)

      vm.$validator.validate().then((valid) => {
        if (valid) {
          if (vm.password.length > 7) {
            vm.$http.post(url, resetinfo).then(function (response) {
              // // console.log(response)
              if (response.data == "200") {
                vm.alertTitle = "ជោគជ័យ";
                vm.alertText =
                  "ពាក្យសម្ងាត់របស់អ្នកត្រូវបានកំណត់ឡើងវិញដោយជោគជ័យ។ សូមចូលដោយប្រើពាក្យសម្ងាត់ថ្មីរបស់អ្នក";
                vm.alertSuccess();
              } else {
                vm.alertText =
                  "ប្រព័ន្ធកំពុងជាប់រវល់ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ";
                vm.alertError();
              }
            });
          } else {
            vm.alertText = "ពាក្យសម្ងាត់ត្រូវតែមាន 8-20 តួអក្សរ";
            vm.alertError();
            vm.$refs.password.style.borderColor = "red";
            vm.$refs.passwordconfirm.style.borderColor = "red";
          }
        } else {
          vm.alertText = "ការបញ្ចូលមិនពេញលេញ សូមពិនិត្យម្តងទៀត";
          vm.alertError();
        }
      });
    },

    alertError() {
      const vm = this;
      vm.$swal({
        // title: vm.alertTitle,
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;

      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        // vm.$router.push({ path: '/en/login' })

        const url = "https://www.chanchao.com.tw/apiLogin2/Logout";

        vm.$http.get(url).then(function (response) {
          document.location.href =
            "https://www.chanchao.com.tw/accounts/km/login";
        });
      });
    },

    showPw() {
      const vm = this;
      vm.typePwd = vm.typePwd === "password" ? "text" : "password";
    },
  },

  created() {
    const vm = this;

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //GET 網址夾帶的參數

    let getUrlString = location.href;
    let getParams = new URL(getUrlString);

    let memberid = getParams.searchParams.get("e");
    let vCode = getParams.searchParams.get("c");

    vm.menberId = memberid;
    vm.verifyCode = vCode;

    const url = `https://www.chanchao.com.tw/apiLogin2/resetPw/${memberid}/${vCode}`;

    vm.$http.get(url).then(function (response) {
      // // console.log(response.data)
      if (response.data == 251 || response.data == 252) {
        alert("តំណបានផុតកំណត់ហើយ។ សូមស្នើសុំថ្មី។");
        vm.$router.push({ path: "/km/forgetPw" });
      } else {
        vm.show = true;
      }
    });

    //更換英文語系
    vm.$i18n.locale = "km";

    //是否登入狀態

    //取cookie

    const url2 = "https://www.chanchao.com.tw/apiLogin2/isAuthenticated";
    const info = null;
    vm.$http.post(url2, info).then(function (response) {
      // console.log(response.data)
      if (response.data == 200) {
        vm.Registered = true;
      } else {
        vm.Registered = false;
      }
    });
  },
};
</script>

<style lang="scss">
//Swal setting
.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 12px;
}

#main-footer {
  bottom: 0;
}

.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.navLogo {
  height: 55px;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.logoText {
  font-size: 20px;
}

@media (max-width: 768px) {
  .navLogo {
    height: 50px;
  }
  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }

  .logoText {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
